import { userConfigAtom } from "@portal/store/userConfig/userConfig";
import {
  DRAFT_FEATURES,
  DRAFT_FEATURE_MODULE,
} from "@portal/types/entities/features";
import { useAtomValue } from "jotai";
import { useCallback } from "react";

function useFeatures() {
  const features = useAtomValue(userConfigAtom).user_details?.user.features;

  function draftFeaturesPredicate(key: DRAFT_FEATURES) {
    const module: DRAFT_FEATURE_MODULE = {
      DRAFT_METRICS: Boolean(features?.includes("DRAFT_METRICS")),
      DRAFT_INVOICE: Boolean(features?.includes("DRAFT_INVOICE")),
    };
    return module[key];
  }

  const getDraftFeatures = useCallback(draftFeaturesPredicate, [features]);

  return { getDraftFeatures };
}
export { useFeatures };
